import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../../../app/hooks/useAxios';

const useAuthOktaUserActivation = () => {
	const { post } = useAxios();

	const userActivate = (activationToken: string) => {
		return post(`/users/activate/token`, { token: activationToken });
	};

	return useMutation(userActivate);
};

export default useAuthOktaUserActivation;
